module.exports = "https://cdn-challenge.mathletics.com/app/299/assets/fonts/e934cbc86e2d59ceaf04102c43dc0b50.woff2";